import React, {useEffect} from 'react';
import {renderRoutes} from 'react-router-config';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {Helmet} from 'react-helmet-async';
import {object} from 'prop-types';
import {TabBar} from 'app/components/tab/TabBar';
import {useSelector, useDispatch} from 'react-redux';
import {createSelector} from 'reselect';
import {useHistory, useParams} from 'react-router';
import {fetchSelectedDistrict} from 'app/actions/sessionActions';
import {ErrorHandler} from 'app/components/error/ErrorHandler';
import useDistrictUrls from 'app/hooks/useDistrictUrls';
import useExtendEAFeatureAvailability from 'app/earlyAccess/useExtendEAFeatureAvailability';
import {ExpFeatDistrictMainPage} from 'app/featureFlags/featureFlags';

const selectDistrict = createSelector(
  state => state.session,
  session => session.district
);

const DistrictPage = ({route}) => {
  const {name} = useSelector(selectDistrict);
  const titleTemplate = `%s ${name}${TITLE_POSTFIX}`;
  const dispatch = useDispatch();
  const history = useHistory();
  const {districtSlug} = useParams();
  const {districtMainUrl, districtMarketplaceUrl, districtTransfersUrl} = useDistrictUrls(districtSlug);

  useEffect(() => {
    // set header on back navigation
    dispatch(fetchSelectedDistrict(districtSlug, 'FuPa', history.location.pathname));
  }, []);

  // Todo: Remove this hook after "Kreisseite 2.0" is fully released
  useExtendEAFeatureAvailability(ExpFeatDistrictMainPage);

  const TabNames = [
    {
      name: 'News',
      url: districtMainUrl,
      rel: districtMainUrl.startsWith('/test_region') ? 'nofollow' : 'follow',
    },
    {
      name: 'Börse',
      url: districtMarketplaceUrl,
      hasSubUrl: true,
    },
    {
      name: 'Transfers',
      url: districtTransfersUrl,
    },
  ];

  return (
    <>
      <Helmet defaultTitle={`${name}${TITLE_POSTFIX}`} titleTemplate={titleTemplate} />
      <TabBar tabs={TabNames} />
      <ErrorHandler subroute={true}>
        {renderRoutes(route.routes, {name, slug: districtSlug, dispatchRedux: dispatch})}
      </ErrorHandler>
    </>
  );
};

DistrictPage.propTypes = {
  route: object.isRequired,
};

export default DistrictPage;
